import http from '@/core/services/http.service';
import {ON_PDF_MODAL_OPEN} from "@/plugins/event-bus/event-bus-names";

export default {
  getDpvHistory(auctionUuid = null, params = null) {
    if (auctionUuid) {
      return http.get(`/api/v1/auctions/${auctionUuid}/dpvs/`, {params});
    }
    return http.get(`/api/v1/auctions/dpvs/`, {params});
  },
  getDpvLots(uuid, params = null) {
    return http.get(`/api/v1/auctions/dpvs/${uuid}/dpv-lots/`, {params});
  },
  async getDpvPdfUrl(vm, uuid) {
    let response = await http.get(`/api/v1/auctions/dpvs/${uuid}/pdf-url/`);
    if (response.success) {
      if (response.body.pdf_url) {
        vm.$evBus.$emit(ON_PDF_MODAL_OPEN, {
          title: vm.$i18n.t('DPV History'),
          data: response.body,
          actions: []
        });
      } else {
        vm.$errorDialog(vm.$i18n.t('fetching pdf failed'));
      }
    } else {
      vm.$errorDialog(vm.$i18n.t('fetching pdf failed'));
    }
  }
};
